document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeSection_MenuDrawer', (position = 'leftDrawer') => {
    return {
      init() {
        initTeleport(this.$root);
        Alpine.store('modals').register('menu-drawer', position);
      },
    };
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}